import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  AUTH_LOGOUT,
  AUTH_LOGOUT_SUCCESS
} from "./reducer";
import { fetchApi } from "../api";
import { setClient, getClientRequest } from "../client/actions";
import { setToken } from "../token/actions";

const API = "https://api.pulse-experience.co";

const apiEndpoints = {
  loginAdmin: "/v1/auth/login-dashboard"
};

const loginApi = data => {
  return fetchApi(apiEndpoints.loginAdmin, data, "post");
};

function* authorize(action) {
  // const options = {
  //   body: JSON.stringify({ email, password }),
  //   method: "POST",
  //   headers: { "Content-Type": "application/json" }
  // };

  try {
    // const { token } = yield call(fetchJSON, API, options);
    const { token, user, client } = yield call(loginApi, action.payload);
    yield put({
      type: AUTH_SUCCESS,
      payload: token,
      userId: user._id,
      clientId: client._id
    });
    localStorage.setItem("token", token.accessToken);
    localStorage.setItem("role", user.role);
    localStorage.setItem("clientId", client._id);
    localStorage.setItem("userId", user._id);
    yield put(setToken(token));
    yield put(setClient(client));
    yield put(getClientRequest({ clientId: client._id }));
  } catch (error) {
    console.log("error");
    console.log(error);
    // let message;
    // switch (error.status) {
    //   case 500:
    //     message = "Internal Server Error";
    //     break;
    //   case 401:
    //     message = "Invalid credentials";
    //     break;
    //   default:
    //     message = "Something went wrong";
    // }
    yield put({ type: AUTH_FAILURE, payload: error.message });
    // localStorage.removeItem("token");
    localStorage.clear();
  }
}

function* logoutFlow(action) {
  yield localStorage.clear();
  yield put({ type: AUTH_LOGOUT_SUCCESS });
}

function* Saga() {
  yield all([
    takeLatest(AUTH_REQUEST, authorize),
    takeLatest(AUTH_LOGOUT, logoutFlow)
  ]);
}

export default Saga;
